import { useStyles } from '@team-griffin/stylr';
import { imageAspectRatioPercentage } from 'presentation/utils/imageAspectRatioPercentage';
import { ImageAspectRatio } from 'domain/constants/imageAspectRatio';

export default ({ imageAspectRatio }: { imageAspectRatio: ImageAspectRatio | undefined }) =>
  useStyles(
    {
      default: {
        outer: {
          position: 'relative',
          width: '100%',
          height: 0,
          paddingTop: imageAspectRatioPercentage(imageAspectRatio),
        },
        inner: {
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          overflow: 'hidden',
        },
        image: {
          position: 'relative',
          top: '50%',
          transform: 'translateY(-50%)',
          width: '100%',
          height: 'auto',
        },
      },
    },
    [{ imageAspectRatio }],
  );
